import {
  activeDirectoryLogin,
  activeDirectoryAutoLogin,
  ActiveDirectoryLoginResponse,
  submit_available
} from 'app/core/http';
import Cookies from 'js-cookie';
import { activeDirectoryLoginFailedMessage } from '../triggerThirdPartyLoginFailedMessage';
import { SurveyConfig } from 'app/core/survey-config';
import { SurveyCakeLogicEngine } from '@surveycake/logic-engine';
import { SetPage } from 'app/core/page';
import { SetException } from 'app/core/status';
import { SetIsCompleted, SetNotAllowed } from '../types';
import { enableAdLoginGoogleRecaptcha } from 'config/system';

export type ActiveDirectoryLoginDeps = [
  SurveyConfig,
  SurveyCakeLogicEngine,
  SetPage,
  SetException,
  SetIsCompleted,
  SetNotAllowed
];

function Redirect(
  deps: ActiveDirectoryLoginDeps,
  response: ActiveDirectoryLoginResponse
) {
  const [
    surveyConfig,
    engine,
    setPage,
    setException,
    setIsCompleted,
    setNotAllowed
  ] = deps;

  if (response.accessToken) {
    Cookies.set('userToken', response.accessToken);
  }

  if (response.refreshToken) {
    Cookies.set('refreshToken', response.refreshToken);
  }

  if (response.mbr_id) {
    Cookies.set('mbr_id', response.mbr_id);
    engine.setThirdPartyLogin(response.mbr_id);
  }

  if (response.errmsg === 'ALREADY_DONE') {
    setIsCompleted(true);
  } else if (response.errmsg === 'NOT_ALLOWED') {
    setNotAllowed(true);
  } else {
    surveyConfig.handleStageFinished(setPage, setException);
  }
}

export async function ActiveDirectoryAutoLogin(deps: ActiveDirectoryLoginDeps) {
  const [surveyConfig] = deps;
  const response: ActiveDirectoryLoginResponse = await activeDirectoryAutoLogin(
    surveyConfig.surveyHash
  );

  if (
    response.status ||
    response.errmsg === 'ALREADY_DONE' ||
    response.errmsg === 'NOT_ALLOWED'
  ) {
    Redirect(deps, response);
  }
}

export async function ActiveDirectoryLogin(
  deps: ActiveDirectoryLoginDeps,
  account: string,
  password: string,
  recaptchaKey: string,
) {
  const [surveyConfig] = deps;
  if (enableAdLoginGoogleRecaptcha) {
    window.grecaptcha.ready(async () => {
      const token = await window.grecaptcha.execute(recaptchaKey, {
        action: 'submit'
      });
      const response: ActiveDirectoryLoginResponse = await activeDirectoryLogin(
        surveyConfig.surveyHash,
        account,
        password,
        token
      );
      const { wording } = surveyConfig;
      if (
        response.status ||
        response.errmsg === 'ALREADY_DONE' ||
        response.errmsg === 'NOT_ALLOWED'
      ) {
        Redirect(deps, response);
      } else if (response.errmsg) {
        activeDirectoryLoginFailedMessage(wording, response.errmsg);
      } else {
        activeDirectoryLoginFailedMessage(wording);
      }
    })
  } else {
    const response: ActiveDirectoryLoginResponse = await activeDirectoryLogin(
      surveyConfig.surveyHash,
      account,
      password
    );
    const { wording } = surveyConfig;
    if (
      response.status ||
      response.errmsg === 'ALREADY_DONE' ||
      response.errmsg === 'NOT_ALLOWED'
    ) {
      Redirect(deps, response);
    } else if (response.errmsg) {
      activeDirectoryLoginFailedMessage(wording, response.errmsg);
    } else {
      activeDirectoryLoginFailedMessage(wording);
    }
  }
}

export async function AlreadySubmit(svid: string, mbr_id: string) {
  const response: ActiveDirectoryLoginResponse = await submit_available(
    svid,
    mbr_id
  );

  if (response.errmsg === 'ALREADY_DONE') {
    return 'ALREADY_DONE';
  } else if (response.errmsg === 'NOT_ALLOWED') {
    return 'NOT_ALLOWED';
  } else {
    return 'NOT_YET';
  }
}
